import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import {RecoilRoot} from "recoil";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import {ErrorPage} from "./pages/ErrorPage";
import LoginPage from "./pages/LoginPage";
import AppointmentOverviewPage from "./pages/AppointmentOverviewPage";
import BaseLayout from "./layouts/BaseLayout";
import AppointmentCreatePage from "./pages/AppointmentCreatePage";
import {MyPage} from "./pages/MyPage";
import {createTheme, ThemeProvider} from "@mui/material";
import {HILIGHT_COLOR} from "./constants/constants";
import DefaultPage from "./pages/DefaultPage";
import OauthCallback from "./pages/OauthCallback";
import {PrivateRoute} from "./components/PrivateRoute";
import {NotLoginRoute} from "./components/NotLoginRoute";
import AppInitializer from "./layouts/AppInitializer";
import {QueryClient, QueryClientProvider} from "react-query";
import NoticePage from "./pages/NoticePage";
import {NoticeDetailPage} from "./pages/NoticeDetailPage";
import {SettingsPage} from "./pages/SettingsPage";
import {PollPage} from "./pages/poll/PollPage";
import {SimpleDocumentPage} from "./pages/SimpleDocumentPage";
import {TERMS_BODY_V1, TERMS_TITLE} from "./constants/termsOfService";
import {PRIVACY_POLICY_BODY_V1, PRIVACY_POLICY_TITLE} from "./constants/privacy";
import {NotificationSettingPage} from "./pages/NotificationSettingPage";
import {SignupPage} from "./pages/SignupPage";

const router = createBrowserRouter([
    {
        path: "/",
        element: <BaseLayout/>,
        errorElement: <ErrorPage/>,
        children: [
            { // can access when logout
                path: "/",
                element: <NotLoginRoute/>,
                children: [
                    {
                        index: true,
                        element: <LoginPage/>
                    },
                    {
                        path: "/login",
                        element: <LoginPage/>
                    },
                    {
                        path: "/oauth",
                        element: <OauthCallback/>,
                    },
                    {
                        path: "/signup",
                        element: <SignupPage />,
                    }
                ],
            },
            { // can access when login
                path: "/",
                element: <PrivateRoute />,
                children: [
                    {
                        path: "/appointments/create",
                        element: <AppointmentCreatePage/>,
                    },
                    {
                        path: "/mypage",
                        element: <MyPage/>
                    },
                    {
                        path: "/default",
                        element: <DefaultPage/>,
                    },
                    {
                        path: "/appointments/:id/poll",
                        element: <PollPage />
                    },
                    {
                        path: "/settings",
                        element: <SettingsPage />
                    },
                    {
                        path: "/settings/notification",
                        element: <NotificationSettingPage />
                    }
                ]
            },
            { // can access without condition
                path: "/appointments/:id",
                element: <AppointmentOverviewPage/>,
            },
            {
                path: "/notice",
                element: <NoticePage />,
            },
            {
                path: "/notice/:id",
                element: <NoticeDetailPage />,
            },
            {
                path: "/policy/terms-of-service",
                element: <SimpleDocumentPage title={TERMS_TITLE} body={TERMS_BODY_V1} />
            },
            {
                path: "/policy/privacy",
                element: <SimpleDocumentPage title={PRIVACY_POLICY_TITLE} body={PRIVACY_POLICY_BODY_V1} />
            },
        ],
    }
]);

// 전역 테마 설정
const theme = createTheme({
    palette: {
        primary: {
            main: HILIGHT_COLOR,
        },
    },
});

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const queryClient = new QueryClient();

root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <RecoilRoot>
                <QueryClientProvider client={queryClient}>
                    <AppInitializer>
                        <RouterProvider router={router}/>
                    </AppInitializer>
                </QueryClientProvider>
            </RecoilRoot>
        </ThemeProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
